'use client';

import { c as _c } from "react/compiler-runtime";
import type { LinearIssue } from '@/lib/linear/types';
import { BaseSearchIssues } from '../../../shared/issue/base-search-issues';
import { useIssueSearch } from '@/data/linear/use-issue-search';
type SearchLinearIssuesProps = {
  onSelectAction: (issue: LinearIssue) => void;
  isOpen: boolean;
  onOpenChangeAction: (open: boolean) => void;
  installationId: number;
};
export function SearchLinearIssues(t0) {
  const $ = _c(10);
  const {
    onSelectAction,
    isOpen,
    onOpenChangeAction,
    installationId
  } = t0;
  const {
    search,
    setSearch,
    debouncedSearch,
    searchResults,
    isLoading,
    error
  } = useIssueSearch(installationId);
  let t1;
  if ($[0] !== debouncedSearch || $[1] !== error || $[2] !== isLoading || $[3] !== isOpen || $[4] !== onOpenChangeAction || $[5] !== onSelectAction || $[6] !== search || $[7] !== searchResults || $[8] !== setSearch) {
    t1 = <BaseSearchIssues isOpen={isOpen} onOpenChangeAction={onOpenChangeAction} search={search} setSearch={setSearch} debouncedSearch={debouncedSearch} searchResults={searchResults} isLoading={isLoading} error={error} onSelectAction={onSelectAction} getIssueKey={_temp} getIssueSummary={_temp2} tooltipContent={_temp3} popoverWidthClass="w-72" />;
    $[0] = debouncedSearch;
    $[1] = error;
    $[2] = isLoading;
    $[3] = isOpen;
    $[4] = onOpenChangeAction;
    $[5] = onSelectAction;
    $[6] = search;
    $[7] = searchResults;
    $[8] = setSearch;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
function _temp3(issue_1) {
  return issue_1.title;
}
function _temp2(issue_0) {
  return issue_0.title;
}
function _temp(issue) {
  return issue.identifier;
}